export const HrisImportPath = '/management_panel/hris_imports'

const viewHrisImportRoute = ({ hrisImportId }) => {
  return `/management_panel/user_changes?hris_import_id=${hrisImportId}`
}

export { viewHrisImportRoute }
